import { ApiService } from "api/api.service";
import { MediaDto } from "dtos/media.dto";
import { useState } from "react";
import { Image } from "antd";

// const GridImage = ({ url, title = "", blogPage = false }: { url?: string; title?: string; blogPage?: boolean }) => {
//   return (
//     <div className="group cursor-pointer relative">
//       <img
//         src={url}
//         alt={title}
//         className={`w-full ${blogPage ? "h-20" : "h-48"} object-cover rounded-lg transition-transform transform scale-100 group-hover:scale-105`}
//       />
//       <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
//         <button className="bg-white text-gray-800 px-4 py-2 rounded-lg hover:bg-gray-200 transition-colors">
//           View
//         </button>
//       </div>
//     </div>
//   );
// };

const GridView = ({ blogPage = false }: { blogPage: boolean }) => {
  const [filters, setFilters] = useState({
    page: 1,
    limit: 100,
  });
  const mediaList = ApiService.media.useGetAllImages();

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 p-4">
      {mediaList.isSuccess &&
        mediaList.data.map((media: string, index: number) => (
          <Image
            src={media}
            key={index}
            style={{
              width: "100%",
              height: "auto",
              maxHeight: "200px",
              objectFit: "cover",
            }}
            className="w-full h-auto max-h-[200px] object-cover"
          />
        ))}
    </div>
  );
};

export default GridView;
